import React from "react";
import { Text } from '@mantine/core';

import { utils } from "../../utils/globalVariables";
import { getObjectParam2 } from "../../utils/globalFunctions";

import InputWrapperCustom from "../../components/general/InputWrapperCustom";

const JenisService = ({ stateData }) => {
    return (
        <React.Fragment>
            <InputWrapperCustom
                stateLabel='Jenis Service'
                stateWithAsterisk={false}
                stateError=''
                stateDescription=''
            >
                <Text size='sm'>
                    {getObjectParam2(utils.projectType, stateData.data.jenis, 'caption', ' - ')} {stateData.data.jenis === utils.projectType.maintenance.value ? `(Reminder setiap ${stateData.data.remind_in} bulan)` : ''}
                </Text>
            </InputWrapperCustom>
        </React.Fragment>
    )
}

export default JenisService;